<template>
  <div class="mob-remove-table-fixed">
    <Card shadow>
      <Row>
        <Col style="text-align: left" :sm="16">
          <Form inline style="height: 41px">
            <FormItem label="需要我审批的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_approval" @on-change="tableSearchForm.need_i_execute=false; getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
            <FormItem label="需要我执行的" :label-width="90" class="mob-w-45">
              <i-switch v-model="tableSearchForm.need_i_execute" @on-change="tableSearchForm.need_i_approval=false; getTableData()">
                <span slot="open"></span>
                <span slot="close"></span>
              </i-switch>
            </FormItem>
          </Form>
        </Col>
        <Col style="text-align: right" :sm="8">
          <Button
            style="margin-bottom: 10px"
            @click="$router.push({ name: 'dbDataMigrateFlowAdd' })"
            type="primary"
            icon="md-add-circle">申请迁移</Button>
        </Col>
        <Divider/>
        <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent style="float: left">
          <FormItem label="标题">
            <Input v-model="tableSearchForm.title" placeholder="" style="min-width: 200px"/>
          </FormItem>
          <FormItem label="申请人">
            <Select v-model="tableSearchForm.applicant" placeholder="" filterable clearable transfer style="min-width: 200px">
              <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
            </Select>
          </FormItem>
          <FormItem label="源实例">
            <Input v-model="tableSearchForm.origin_instance_name" placeholder="" style="min-width: 200px"/>
          </FormItem>
          <FormItem label="目标实例">
            <Input v-model="tableSearchForm.target_instance_name" placeholder="" style="min-width: 200px"/>
          </FormItem>
          <FormItem label="源库">
            <Input v-model="tableSearchForm.origin_db" placeholder="" style="min-width: 200px"/>
          </FormItem>
          <FormItem label="目标库">
            <Input v-model="tableSearchForm.target_db" placeholder="" style="min-width: 200px"/>
          </FormItem>
          <FormItem label="源表">
            <Input v-model="tableSearchForm.origin_tab" placeholder="" style="min-width: 200px"/>
          </FormItem>
          <FormItem label="申请时间">
            <DatePicker type="daterange" placement="bottom-end" placeholder=""
                        v-model="tableSearchForm.application_time"
                        style="min-width: 200px"
                        @on-change="searchApplicationTimeChange"
                        class="mob-w-100"></DatePicker>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getTableData()">搜索</Button>
            <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
          </FormItem>
        </Form>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getDbDataMigrateFlow, deleteDbDataMigrateFlow } from '@/api/workflow/db_data_migrate_flow'
import { GetALLUsers } from '@/api/user'
import moment from 'moment'
export default {
  name: 'list',
  data () {
    return {
      tableLoading: false,
      listError: false,
      table: {
        data: [],
        columns: [
          {
            title: '标题',
            key: 'title',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '申请人',
            key: 'applicant',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.applicant.name ? params.row.applicant.name : params.row.applicant.username)
            }
          },
          {
            title: '项目',
            key: 'tenant_name',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '源实例',
            key: 'origin_instance_id',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.origin_instance_name ? params.row.origin_instance_name : params.row.origin_instance_id)
            }
          },
          {
            title: '目标实例',
            key: 'target_instance_id',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.target_instance_name ? params.row.target_instance_name : params.row.target_instance_id)
            }
          },
          {
            title: '源库',
            key: 'origin_db',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '目标库',
            key: 'target_db',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '源表',
            key: 'origin_tab',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '申请时间',
            key: 'application_time',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.application_time) {
                return h('span', moment(params.row.application_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.execute_status === 2 || params.row.execute_status === 3) {
                return h('Tag', {
                  props: {
                    color: params.row.execute_status === 2 ? 'green' : 'red'
                  }
                }, params.row.execute_status === 2 ? '执行成功' : '执行失败')
              } else if (params.row.status_verbose) {
                return h('Tag', {
                  props: {
                    color: params.row.status_verbose === '已迁移' ? 'green'
                      : params.row.status_verbose === '驳回' ? 'red'
                        : params.row.status_verbose === '迁移中' ? 'orange'
                          : 'blue'
                  }
                }, params.row.status_verbose)
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'dbDataMigrateFlowDetail', params: { id: params.row.id }, query: { lastPage: this.table.page }})
                    }
                  }
                }, '详情'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  style: {
                    display: params.row.status === 1 && (this.$store.state.user.superuser || this.$store.state.user.userId === params.row.applicant.id) ? 'inline-block' : 'none'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      tableSearchForm: {
        applicant: '',
        title: '',
        origin_instance_name: '',
        target_instance_name: '',
        origin_db: '',
        target_db: '',
        origin_tab: '',
        application_time: '',
        application_time_after: '',
        application_time_before: '',
        need_i_approval: false,
        need_i_execute: false
      },
      userList: [],
      moment: moment
    }
  },
  created: function () {
    this.getTableData(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
    this.getAllUserData()
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      getDbDataMigrateFlow(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    delete (id) {
      deleteDbDataMigrateFlow(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '删除失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '删除失败！'
          })
        }
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        applicant: '',
        title: '',
        origin_instance_name: '',
        target_instance_name: '',
        origin_db: '',
        target_db: '',
        origin_tab: '',
        application_time: '',
        application_time_after: '',
        application_time_before: '',
        need_i_approval: this.tableSearchForm.need_i_approval,
        need_i_execute: this.tableSearchForm.need_i_execute
      }
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    searchApplicationTimeChange (value) {
      this.tableSearchForm.application_time_after = value[0]
      this.tableSearchForm.application_time_before = value[1]
    }
  }
}
</script>

<style scoped>

</style>
